<template>
    <div v-click-outside="onClickOutside">
        <div class="card editUserCard">
            <div :class="[[0,1,2,3].indexOf(index) >=0 ? `triangle-${getUsersLength.length-index}` : 'triangle']"></div>
            <div class="card-body">
                <div class="showSingleUserCircle">
                    <div>{{tools.userInitial(user)}}</div>
                </div>
                <div class="name">{{user.name}}</div>
                <form v-on:submit.prevent>
                    <dl class="card-text clearfix">
                        <dt class="cardInfo">Title:</dt>
                        <dd class="cardDescription">
                            <input type="text" maxlength="32" class="form-control addInputField" required
                                   placeholder="User title"
                                   v-model="form.title"
                            >
                        </dd>
                        <dt class="cardInfo">Role:</dt>
                        <dd class="cardDescription">
                            <select class="form-control form-control-sm" id="role"
                                    v-model="buildingRole.id" v-bind:disabled="isPatchMode">
                                <option v-for="(buildingRole,index) in buildingRoles" :value="buildingRole.id">
                                    {{buildingRole.display_name}}
                                </option>
                            </select>
                        </dd>
                    </dl>

                    <div class="buttons">
                        <a href="javascript:void(0)" class="cancelButton" @click="$emit('close')">Cancel</a>
                        <template v-if="canUpdateMethod(user)">
                            <button type="button" class="btn btn-primary float-right btn-sm" v-if="isPatchMode"
                                    v-on:click="updateTitle(buildingId)"
                                    v-bind:disabled="isUpdating || isRemoving"
                            >
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="isUpdating"></span>
                              Update
                            </button>
                            <button type="button" class="btn btn-primary float-right btn-sm" v-else
                                    v-on:click="updateRole(buildingId)"
                                    v-bind:disabled="isUpdating || isRemoving"
                            >
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="isUpdating"></span>
                              Update
                            </button>
                        </template>
                        <template v-if="canRemoveMethod(user)">
                            <button type="button" class="btn btn-outline-danger float-right btn-sm removeButton"
                                    v-on:click="deleteConfirmModal()"
                                    v-bind:disabled="isUpdating || isRemoving"
                            >
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="isRemoving"></span>
                              Remove User
                            </button>
                        </template>
                    </div>
                </form>
            </div>
        </div>

        <InfoModalComponent
                v-if="dataToPassToInfoModal.showModal"
                :confirm="dataToPassToInfoModal"
                @close="dataToPassToInfoModal.showModal = false;
                $emit('updateUsers');
                $emit('close')"
        ></InfoModalComponent>
        <DeleteModalComponent
                v-if="deleteModal.showModal"
                @delete="removeRole(buildingId);
                        $emit('updateUsers');
                        deleteModal.showModal = false"
                @close="deleteModal.showModal = false"
                :confirm="deleteModal.confirm">
        </DeleteModalComponent>
    </div>
</template>
<script>
import InfoModalComponent from '@/components/modal/InfoComponent.vue';
import DeleteModalComponent from '@/components/modal/DeleteModalComponent.vue';
import Tools from '@/app-model/tools.js';
import User from '@/app-model/user.js';
import vClickOutside from 'v-click-outside'

export default {
    props: {
      buildingRoles: Array,
      user: Object,
      title: String,
      isPatchMode: Boolean,
      buildingId: [String, Number],
      index: [String, Number],
      buildingRole: Object,
      users: Array
    },
    data () {
      return {
        dataToPassToInfoModal: {
          showModal: false,
          success: false,
          title: '',
          msg: '',
        },
        deleteModal: {
          showModal: false,
          confirm: {
            title: '',
            msg: ''
          }
        },
        form: {
          title: this.title
        },
        isUpdating: false,
        isRemoving: false,
      }
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    components: {
      InfoModalComponent,
      DeleteModalComponent,
    },
    methods: {
      onClickOutside() {
        this.$emit('close')
      },
      /**
       * @return {boolean}
       */
      canUpdateMethod(user) {
        return this.userModel.canUpdateUserBuildingRoleToUser({store: this.$store, user}, this.canUpdateRole)
          || this.userModel.canUpdateUserBuildingTitleToUser({store: this.$store, user}, this.canUpdateTitle);
      },
      /**
       * @return {boolean}
       */
      canRemoveMethod (user) {
        return this.userModel.canRemoveUserBuildingRoleToUser({store: this.$store, user}, this.canRemove);
      },
      deleteConfirmModal: function () {
        this.deleteModal.showModal = true
        this.deleteModal.confirm.title = 'Are you sure you want to remove this user?';
        this.deleteModal.confirm.msg = 'This action will remove the user from the building';
      },
      updateTitle: function (buildingId) {
        this.isUpdating = true;
        return this.userModel.updateUserBuildingTitle(
          {
            store: this.$store,
            buildingId
          },
          this.user.id,
          this.form.title
        ).then(response => {
          if (buildingId === this.buildingId) {
            switch (response.status) {
              case 401:
              case 410:
              case 422:
                this.dataToPassToInfoModal.showModal = true
                this.dataToPassToInfoModal.success = false
                this.dataToPassToInfoModal.title = 'Error'
                this.dataToPassToInfoModal.msg = response.data.message
                break;
              case 200:
                this.dataToPassToInfoModal.showModal = true
                this.dataToPassToInfoModal.success = true
                this.dataToPassToInfoModal.title = 'Title Updated'
                this.dataToPassToInfoModal.msg = 'Title has been successfully updated.'
                break;
              default:
                console.error('Failed to update title', response)
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = false;
                this.dataToPassToInfoModal.title = 'Error';
                this.dataToPassToInfoModal.msg = 'An unexpected error occurred, please try again later.';
                break;
            }
          }
        }).catch((e) => {
          console.error('Failed to update title', e)
          this.dataToPassToInfoModal.showModal = true;
          this.dataToPassToInfoModal.success = false;
          this.dataToPassToInfoModal.title = 'Error';
          this.dataToPassToInfoModal.msg = 'An unexpected error occurred, please try again later.';
        }).finally(() => this.isUpdating = false);
      },
      updateRole: function (buildingId) {
        this.isUpdating = true;
        return this.userModel.updateUserBuildingRole(
          {
            store: this.$store,
            buildingId
          },
          this.user.id,
          this.buildingRole.id,
          {
            title: this.form.title
          }
        ).then(response => {
          if (buildingId === this.buildingId) {
            switch (response.status) {
              case 401:
              case 410:
              case 422:
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = false;
                this.dataToPassToInfoModal.title = 'Error';
                this.dataToPassToInfoModal.msg = response.data.message;
                break;
              case 200:
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = true;
                this.dataToPassToInfoModal.title = 'Role Updated';
                this.dataToPassToInfoModal.msg = 'Role has been successfully updated.';
                break;
              default:
                console.error('Failed to update role', response)
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = false;
                this.dataToPassToInfoModal.title = 'Error';
                this.dataToPassToInfoModal.msg = 'An unexpected error occurred, please try again later.';
                break;
            }
          }
        }).catch((e) => {
          console.error('Failed to update role', e)
          this.dataToPassToInfoModal.showModal = true;
          this.dataToPassToInfoModal.success = false;
          this.dataToPassToInfoModal.title = 'Error';
          this.dataToPassToInfoModal.msg = 'An unexpected error occurred, please try again later.';
        }).finally(() => this.isUpdating = false);
      },

      removeRole: function (buildingId) {
        this.isRemoving = true;
        return this.userModel.removeUserBuildingRole(
          {
            store: this.$store,
            buildingId
          },
          this.user.id
        ).then(response => {
          if (buildingId === this.buildingId) {
            switch (response.status) {
              case 200:
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = true;
                this.dataToPassToInfoModal.title = 'Removed successfully';
                this.dataToPassToInfoModal.msg = 'User has been removed from the building';
                break;

              case 401:
              case 410:
              case 422:
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = false;
                this.dataToPassToInfoModal.title = 'Error';
                this.dataToPassToInfoModal.msg = response.data.message;
                break;
              default:
                console.error('Failed to remove user', response)
                this.dataToPassToInfoModal.showModal = true;
                this.dataToPassToInfoModal.success = false;
                this.dataToPassToInfoModal.title = 'Error';
                this.dataToPassToInfoModal.msg = 'An unexpected error occurred, please try again later.';
                break;
            }
          }
        }).catch((e) => {
          console.error('Failed to remove user', e)
          this.dataToPassToInfoModal.showModal = true;
          this.dataToPassToInfoModal.success = false;
          this.dataToPassToInfoModal.title = 'Error';
          this.dataToPassToInfoModal.msg = 'An unexpected error occurred, please try again later.';
        }).finally(() => this.isRemoving = false);
      }
    },
    computed: {
      tools: function() {
        return new Tools;
      },
      userModel: function() {
        return new User;
      },
      /**
       * @return {boolean}
       */
      canUpdateRole () {
        return this.userModel.canUpdateUserBuildingRole({store: this.$store, buildingId: this.buildingId});
      },
      /**
       * @return {boolean}
       */
      canUpdateTitle () {
        return this.userModel.canUpdateUserBuildingTitle({store: this.$store, buildingId: this.buildingId});
      },
      /**
       * @return {boolean}
       */
      canRemove () {
        return this.userModel.canRemoveUserBuildingRole({store: this.$store, buildingId: this.buildingId});
      },
      getUsersLength () {
        if (this.users.length > 4) {
          return this.users.slice(0, 4)
        }
        return this.users
      },
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_users.scss";
</style>